import React, { useMemo, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import type { FracSimulation } from './types';
import {
  ENGINEERING_CURVE_METRICS,
  buildEngineeringCurveRows,
  type EngineeringCurveMetricId,
} from './simulationEngineeringCurves';

const COLORS = ['#C2533A', '#2874A6', '#1E8449', '#6A4C93', '#D4770C'];

export default function SimulationComparisonCurves({ simulations, stageNumber }: {
  simulations: FracSimulation[];
  stageNumber?: number;
}) {
  const [metric, setMetric] = useState<EngineeringCurveMetricId>('bottomholePressure');
  const definition = ENGINEERING_CURVE_METRICS[metric];
  const rows = useMemo(() => simulations.map((simulation) => ({
    simulation,
    rows: buildEngineeringCurveRows(simulation.results ?? [], stageNumber === undefined
      ? { kind: 'WELL' }
      : { kind: 'STAGE', stageNumber }),
  })), [simulations, stageNumber]);
  const option = useMemo(() => ({
    animation: false,
    color: COLORS,
    grid: { left: 58, right: 24, top: 38, bottom: 50 },
    legend: { top: 5, type: 'scroll', textStyle: { fontSize: 10 } },
    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
    dataZoom: [{ type: 'inside' }, { type: 'slider', height: 14, bottom: 8 }],
    xAxis: { type: 'value', name: '时间 (min)', axisLabel: { formatter: (value: number) => (value / 60).toFixed(1) } },
    yAxis: { type: 'value', name: `${definition.label} (${definition.unit})`, scale: true },
    series: rows.map(({ simulation, rows: points }) => ({
      name: `#${simulation.id} ${simulation.design_name}`,
      type: 'line', showSymbol: points.length < 30, connectNulls: false,
      data: points.map((point) => [point.timeS, point[metric]]),
    })),
  }), [rows, metric, definition]);
  const unavailable = rows.filter(({ rows: points }) => !points.some((point) => point[metric] !== null));
  return <div style={{ border: '1px solid #D6DAE0', background: '#fff' }}>
    <div style={{ padding: '5px 9px', display: 'flex', gap: 8, alignItems: 'center', borderBottom: '1px solid #D6DAE0', fontSize: 10 }}>
      <strong>动态曲线叠加</strong>
      <select value={metric} onChange={(event) => setMetric(event.target.value as EngineeringCurveMetricId)} style={{ fontSize: 10 }}>
        {(Object.keys(ENGINEERING_CURVE_METRICS) as EngineeringCurveMetricId[]).map((id) => <option key={id} value={id}>{ENGINEERING_CURVE_METRICS[id].label}</option>)}
      </select>
      <span style={{ color: '#708399' }}>{definition.definition}</span>
      {unavailable.length > 0 && <span style={{ color: '#A64B32' }}>缺数据：{unavailable.map(({ simulation }) => `#${simulation.id}`).join('、')}</span>}
    </div>
    <ReactECharts option={option} notMerge style={{ height: 270 }} />
  </div>;
}
